import {
  CALL_INSIGHTS_LOADING,
  CALL_INSIGHTS_SUCCESS,
  CALL_INSIGHTS_FAILURE,
  CALL_INSIGHTS_RESET,
} from "../constants/callInsights.constants";

// `calls` stays null until a response lands, so the UI can tell "not fetched
// yet" (show the spinner) from "fetched, no calls" (show the empty state).
// `otherOpportunities` holds the sibling opportunities on the same housing
// profile, listed below the viewed one.
const defaultState = {
  calls: null,
  otherOpportunities: [],
  loading: false,
  forbidden: false,
};

export default function callInsights(state = {}, action) {
  const currentState = state.callInsights || defaultState;

  switch (action.type) {
    case CALL_INSIGHTS_LOADING:
      return {
        ...state,
        callInsights: {
          ...currentState,
          loading: action.payload,
        },
      };

    case CALL_INSIGHTS_SUCCESS:
      return {
        ...state,
        callInsights: {
          ...currentState,
          loading: false,
          forbidden: false,
          calls: action.payload?.calls || [],
          otherOpportunities: action.payload?.otherOpportunities || [],
        },
      };

    // Deliberately leaves `calls` alone: a failed refresh must not blank out
    // recordings that are already on screen.
    case CALL_INSIGHTS_FAILURE:
      return {
        ...state,
        callInsights: {
          ...currentState,
          loading: false,
          forbidden: !!action.payload?.forbidden,
        },
      };

    case CALL_INSIGHTS_RESET:
      return {
        ...state,
        callInsights: { ...defaultState },
      };
  }
}
